import { useState, useEffect, Fragment, useCallback, ChangeEvent } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import { ResponseSuccessModal, ResponseFailModal } from '../../components/Modal/Response';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../stores';
import BlackCreate from '../../components/BlackList/BlackCreate';
import { changeField, changeResult, createBlackListAction, initialize, listBlackAction } from '../../stores/blackList';
import { BlackCreateContainerProps } from '../../types/blackList';

const BlackCreateContainer = ({
  isOpen,
  breadcrumbItems,
  toggle,
  reload,
}:BlackCreateContainerProps) => {
  const hotelId = localStorage.getItem('hotel_id');
  const hotelName = breadcrumbItems[1].title as string;

  const dispatch = useDispatch();
  const { blackListItem, blackCreateSuccess, blackCreateError, } = useSelector(({ blackList }:RootState) => ({
      blackListItem: blackList.blackList,
      blackCreateSuccess: blackList.blackCreateSuccess,
      blackCreateError: blackList.blackCreateError,
  }));
  const [ isOpenBlackListCreateSuccessModal, setIsOpenBlackListCreateSuccessModal ] = useState<boolean>(false);
  const [ isOpenBlackListCreateFailModal, setIsOpenBlackListCreateFailModal ] = useState<boolean>(false);
  const [ isOpenRequiredParameterFailModal, setIsOpenRequiredParameterFailModal ] = useState<boolean>(false);
  const [ messageBlackListCreateFail, setMessageBlackListCreateFail ] = useState<string>('');

  //인풋 변경 이벤트 핸들러
  const handleChange = useCallback((e:ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLSelectElement>) => {
      const { value, name } = e.target;
      dispatch(
          changeField({
              key: name,
              value: value,
          })
      );
  },[dispatch]);

  const handleCreateBlackList = useCallback(() => {
    if (!blackListItem.room_no && !blackListItem.room_type_code){
      setIsOpenRequiredParameterFailModal(true); 
      return;
    }
    dispatch(createBlackListAction({
      ...blackListItem, 
      hotel_name: hotelName 
    }));
  },[blackListItem, hotelName, dispatch]);

  useEffect(() => {
    if (isOpen){
      dispatch(listBlackAction());
      dispatch(initialize());
    } 
  }, [isOpen, hotelId, dispatch]);

  useEffect(() => {
    if(blackCreateError){
      if (!blackCreateError.response){
        setMessageBlackListCreateFail(blackCreateError.message);
        setIsOpenBlackListCreateFailModal(true);
      }else{
        if (blackCreateError.response.data === undefined){
          setMessageBlackListCreateFail(blackCreateError.message);
        }else{
          setMessageBlackListCreateFail(`${blackCreateError.response.data.code}, ${blackCreateError.response.data.message}`);
          if(blackCreateError.response.data?.code === 401 || blackCreateError.response.data?.code === 419) reload();
        }
        setIsOpenBlackListCreateFailModal(true);
      }
      dispatch(changeResult({
        key: 'blackCreateError',
        value: null,
      }));
      return;
    }
    if(blackCreateSuccess){
        toggle();
        setIsOpenBlackListCreateSuccessModal(true);
        setTimeout(() => {
          setIsOpenBlackListCreateSuccessModal(false);
          reload();
        }, 1500);
        dispatch(
          changeResult({
            key: 'blackCreateSuccess',
            value: false,
          })
        );
    }
  },[blackCreateSuccess, blackCreateError, toggle, reload, dispatch]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
      >
        <ModalBody className='text-center m-3' style={{margin:0, padding:0}}>
          <BlackCreate 
            blackListItem={blackListItem}
            hotelName={hotelName}
            handleChange={handleChange}
            handleCreateBlackList={handleCreateBlackList}
            toggle={toggle}
          />
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBlackListCreateSuccessModal}
        toggle={() => setIsOpenBlackListCreateSuccessModal(!isOpenBlackListCreateSuccessModal)}
        message='객실이 추가 완료 되었습니다.'
      />
      <ResponseFailModal
        isOpen={isOpenBlackListCreateFailModal}
        toggle={() => setIsOpenBlackListCreateFailModal(!isOpenBlackListCreateFailModal)}
        message={messageBlackListCreateFail || '객실 추가에 실패 하였습니다.'}
      />
      <ResponseFailModal
        isOpen={isOpenRequiredParameterFailModal}
        toggle={() => setIsOpenRequiredParameterFailModal(!isOpenRequiredParameterFailModal)}
        message='필수 입력값을 확인 해주세요.'
      />
    </Fragment>
  );
};

export default BlackCreateContainer;